

const NotFoundRoute = () => {


    return (
        <h2>The page you are looking for is not found 404</h2>
    )

}


export default NotFoundRoute;